<template>
  <div>
    <my-header></my-header>

    <div class="container-fluid">
      <h1>Level#{{levelNumber}} {{levelVarName}} rev: {{revisionNumber}}</h1>

      <table class="m3-props-table mb-4">
        <tr>
          <td>
            Последовательность
          </td>
          <td>
            <router-link :to="{name: 'sequence_levels', params: {sequence_id: sequenceProtoId}, query: sequenceQuery}">
              {{sequenceProtoId | getProtoAlias}}
            </router-link>
          </td>
        </tr>
        <!--
        <tr>
          <td>Номер уровня</td>
          <td>{{levelNumber}}</td>
        </tr>
        <tr>
          <td>Вариант уровня</td>
          <td>{{levelVarName}}</td>
        </tr>
        -->
        <tr>
          <td>Аудитория</td>
          <td>{{audienceId | getAudienceName}}</td>
        </tr>
      </table>

      <!-- TODO: load data for audience selector -->
      <audience-selector v-if="false" />

      <template v-if="isLoadedNormal">

        <!-- Статистика по активной ревизия за 7 дней -->
        <div v-if="activeRevision7DaysStat">
          <h3>Активная ревизия (7 дней)</h3>
          <table class="stat-table table table-striped table-bordered table-sticky table-sm">
            <thead>
              <tr>
                <th scope="col">Revision</th>
                <th scope="col">Average turns</th>
                <th scope="col">Average winner turns</th>
                <th scope="col">Fail Rate w/ boostres</th>
                <th scope="col">Fail Rate w/o boostres</th>
                <th scope="col">Average fails w/ boosters</th>
                <th scope="col">Average fails w/o boosters</th>
                <th scope="col">Average fails before win</th>
                <th scope="col">Average used money total</th>
                <th scope="col">Pass rate</th>
                <th scope="col">Drop rate</th>
                <th scope="col">Sacrifice ratio</th>
                <th scope="col">Conversion into payer</th>
                <th scope="col">Monetization quality</th>
                <th scope="col">Boosters usage rate</th>
                <th scope="col">Coolness factor</th>
                <th scope="col">Players</th>
                <th scope="col">Winners</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-right">
                  {{activeRevision7DaysStat.LevelID.Revision}}
                  <revision-link :revisionId="activeRevision7DaysStat.LevelID | convertLevelIDObjToRevisionId" :audienceId="audienceId | zeroToNull">
                    ...
                  </revision-link>
                </td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(         activeRevision7DaysStat.averageTurnAmount)                }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(         activeRevision7DaysStat.averageWinnerTurnAmount)                }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(activeRevision7DaysStat.FailRate.WithBoosters)            }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(activeRevision7DaysStat.FailRate.WithoutBoosters)         }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(         activeRevision7DaysStat.AverageFails.WithBoosters)        }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(         activeRevision7DaysStat.AverageFails.WithoutBoosters)     }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(         activeRevision7DaysStat.averageFailAmountBeforeFirstWin)  }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(         activeRevision7DaysStat.averageUsedMoneyTotal)            }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(activeRevision7DaysStat.PassRate)                         }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(activeRevision7DaysStat.DropRate)                         }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(activeRevision7DaysStat.sacrificeRatio)                   }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(activeRevision7DaysStat.payerConversion)                  }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(         activeRevision7DaysStat.MonetizationQuality)              }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(activeRevision7DaysStat.extraUsageRate)                   }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(         activeRevision7DaysStat.CoolnessFactor)                   }}</td>
                <td class="text-nowrap text-monospace text-right">{{                      activeRevision7DaysStat.TotalPlayers | getFormattedNumber }}</td>
                <td class="text-nowrap text-monospace text-right">{{                      activeRevision7DaysStat.PassedPlayers | getFormattedNumber}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Статистика по ревизиям -->
        <div>
          <h3>Ревизии</h3>
          <table class="stat-table table table-striped table-bordered table-sticky table-sm">
            <thead>
              <tr>
                <th scope="col">Revision</th>
                <th scope="col">Average turns</th>
                <th scope="col">Average winner turns</th>
                <th scope="col">Fail Rate w/ boostres</th>
                <th scope="col">Fail Rate w/o boostres</th>
                <th scope="col">Average fails w/ boosters</th>
                <th scope="col">Average fails w/o boosters</th>
                <th scope="col">Average fails before win</th>
                <th scope="col">Average used money total</th>
                <th scope="col">Pass rate</th>
                <th scope="col">Drop rate</th>
                <th scope="col">Sacrifice ratio</th>
                <th scope="col">Conversion into payer</th>
                <th scope="col">Monetization quality</th>
                <th scope="col">Boosters usage rate</th>
                <th scope="col">Coolness factor</th>
                <th scope="col">Players</th>
                <th scope="col">Winners</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!level.LevelStats.ByRevision.length"><td colspan="28">N/A</td> </tr>

              <tr v-for="stat in level.LevelStats.ByRevision" :key="stat.LevelID.Revision">
                <td class="text-right">
                  {{stat.LevelID.Revision}}
                  <revision-link :revisionId="stat.LevelID | convertLevelIDObjToRevisionId" :audienceId="audienceId | zeroToNull">
                    ...
                  </revision-link>
                </td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(stat.averageTurnAmount) }} </td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(stat.averageWinnerTurnAmount) }} </td>
                <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(stat.FailRate.WithBoosters) }} </td>
                <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(stat.FailRate.WithoutBoosters) }} </td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(stat.AverageFails.WithBoosters) }} </td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(stat.AverageFails.WithoutBoosters) }} </td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(stat.averageFailAmountBeforeFirstWin)}} </td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(stat.averageUsedMoneyTotal)}} </td>
                <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(stat.PassRate) }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(stat.DropRate) }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(stat.sacrificeRatio) }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(stat.payerConversion) }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(stat.MonetizationQuality) }}</td>
                <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(stat.extraUsageRate) }} </td>
                <td class="text-nowrap text-monospace text-right">{{ formatValue(stat.CoolnessFactor)        }}</td>
                <td class="text-nowrap text-monospace text-right">{{ stat.TotalPlayers | getFormattedNumber  }}</td>
                <td class="text-nowrap text-monospace text-right">{{ stat.PassedPlayers | getFormattedNumber }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Статистика по A/B тестам -->
        <div>
          <h3> Статистика по A/B тесту уровня </h3>
          <table class="stat-table table table-striped table-bordered table-sticky table-sm">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Revision</th>
                <th scope="col">Average turns</th>
                <th scope="col">Average winner turns</th>
                <th scope="col">Fail Rate w/ boostres</th>
                <th scope="col">Fail Rate w/o boostres</th>
                <th scope="col">Average fails w/ boosters</th>
                <th scope="col">Average fails w/o boosters</th>
                <th scope="col">Average fails before win</th>
                <th scope="col">Average used money total</th>
                <th scope="col">Pass rate</th>
                <th scope="col">Drop rate</th>
                <th scope="col">Sacrifice ratio</th>
                <th scope="col">Conversion into payer</th>
                <th scope="col">Monetization quality</th>
                <th scope="col">Boosters usage rate</th>
                <th scope="col">Coolness factor</th>
                <th scope="col">Players</th>
                <th scope="col">Winners</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!hasABTestLevels"><td colspan="28">N/A</td> </tr>

              <template v-if="hasABTestLevels">
                <tr v-for="abLevel in level.ABTestLevels" :key="abLevel.ID.ProtoID">
                  <td class="text-right">{{ abLevel.Name }}</td>
                  <td class="text-right">{{ abLevel.ID.Revision }}</td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValue(abLevel.Stats.averageTurnAmount) }} </td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValue(abLevel.Stats.averageWinnerTurnAmount) }} </td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(abLevel.Stats.FailRate.WithBoosters) }} </td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(abLevel.Stats.FailRate.WithoutBoosters) }} </td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValue(abLevel.Stats.AverageFails.WithBoosters) }} </td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValue(abLevel.Stats.AverageFails.WithoutBoosters) }} </td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValue(abLevel.Stats.averageFailAmountBeforeFirstWin)}} </td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValue(abLevel.Stats.averageUsedMoneyTotal)}} </td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(abLevel.Stats.PassRate) }}</td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(abLevel.Stats.DropRate) }}</td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(abLevel.Stats.sacrificeRatio) }}</td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(abLevel.Stats.payerConversion) }}</td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValue(abLevel.Stats.MonetizationQuality) }}</td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(abLevel.Stats.extraUsageRate) }} </td>
                  <td class="text-nowrap text-monospace text-right">{{ formatValue(abLevel.Stats.CoolnessFactor) }}</td>
                  <td class="text-nowrap text-monospace text-right">{{ abLevel.Stats.TotalPlayers | getFormattedNumber }}</td>
                  <td class="text-nowrap text-monospace text-right">{{ abLevel.Stats.PassedPlayers | getFormattedNumber }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>


        <!-- Распределение ходов успешных попыток без бустеров -->
        <div class="row mb-3">
          <div class="col-md-12">
            <Plotly :data="plotly_turns_taken_without_boosters_data" :layout="plotly_turns_taken_without_boosters_layout"></Plotly>
          </div>
        </div>

        <!-- Распределение неудачных попыток для выигрышей без бустеров -->
        <div class="row mb-3">
          <div class="col-md-12">
            <Plotly :data="plotly_attempts_before_win_without_boosters_data" :layout="plotly_attempts_before_win_without_boosters_layout" ></Plotly>
          </div>
        </div>

        <!-- Среднее число попыток по сидам -->
        <div class="row mb-3">
          <div class="col-md-12">
            <Plotly :data="plotly_avg_attempts_to_win_by_seed_data" :layout="plotly_avg_attempts_to_win_by_seed_layout" ></Plotly>
          </div>
        </div>

        <!-- Графики завершения для целей??? -->
        <template v-for="(goal, index) in level.Goals">
          <div :key="goal.Number" class="row mb-3">
            <div class="col-md-12">
              <Plotly :data="plotly_goal_progress_data[index]" :layout="plotly_goal_progress_layout[index]" ></Plotly>
            </div>
          </div>
        </template>

        <!-- Распределение ходов успешных попыток в целом -->
        <div class="row mb-3">
          <div class="col-md-12">
            <Plotly :data="plotly_turns_taken_data" :layout="plotly_turns_taken_layout"></Plotly>
          </div>
        </div>

        <!-- Распределение неудачных попыток для выигрышей в целом -->
        <div class="row mb-3">
          <div class="col-md-12">
            <Plotly :data="plotly_attempts_before_win_data" :layout="plotly_attempts_before_win_layout" ></Plotly>
          </div>
        </div>

        <!-- Распределение попыток -->
        <div class="row mb-3">
          <div class="col-md-12">
            <Plotly :data="plotly_attempts_data" :layout="plotly_attempts_layout" ></Plotly>
          </div>
        </div>

        <hr>

        <div class="report-info text-muted">
          <p class="gen-time">
            Report generation time: {{reportGenerationTime | getMomentStr}}
          </p>

          <delayed-action-button
            v-if="mayManage"
            @click="update()"
            :enabled="canInteract"
            :running="updating"
            idleLabel="Update"
            runningLabel="Updating"
          />

          <delayed-action-button
            v-if="IS_DEV && mayManage"
            @click="updateActualRevisionStat()"
            :enabled="canInteract"
            :running="updating"
            idleLabel="Update stat for actual revision"
            runningLabel="Updating"
          />
        </div>

      </template>

      <loading-indicator
        v-if="isLoading"
      />

    </div>
  </div>
</template>

<script>
import auth from '../../auth.js';
import MyHeader from '../Header.vue';
import LoadingIndicator from '../LoadingIndicator.vue';
import DelayedActionButton from '../DelayedActionButton.vue';
import AudienceSelector from './AudienceSelector.vue';
import RevisionLink from './RevisionLink.vue';
import notifier from '../../notifier.js';
import { HTTP } from '../../http-common.js';
import { Plotly } from 'vue-plotly';

import { LevelVarId                       } from '../../model/m3level.js';
import { getLevelVarName                  } from '../../model/m3level.js';
import { convertLevelIDObjToRevisionId    } from '../../model/m3level.js';
import { getAudienceName                  } from '../../model/m3level.js';

import { isRoleAdmin                      } from '../../util.js';
import { convertOptionalValueToQueryParam } from '../../util.js';
import { zeroToNull                       } from '../../util.js';
import { genTraceId                       } from '../../util.js';
import { TRACE_ID_HEADER_NAME             } from '../../util.js';

import { IS_DEV                           } from '../../autogen/version.js';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'LevelVar',

  components: {
    MyHeader,
    LoadingIndicator,
    DelayedActionButton,
    Plotly,
    AudienceSelector,
    RevisionLink,
  },

  props: {
    levelVarId: {
      type: LevelVarId,
      required: true,
    },

    audienceId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      IS_DEV,

      actor: auth.getViewer(),

      loadState: LOAD_STATE_INIT,

      level: {
        ID: {
        },
        LevelStats: {
          ByRevision: [],
        },
        Name: '',
        TurnsLimit: 0
      },

      /** @type {?number} */
      reportGenerationTime: null,

      plotly_avg_attempts_to_win_by_seed_data: [{
        type: 'bar',
        x: [],
        y: [],
      }],

      plotly_avg_attempts_to_win_by_seed_layout: {
        title: 'Average attempts to win by seed',
      },

      //-----------------------------------------------------------------------

      plotly_attempts_before_win_data: [{
        type: 'bar',
        x: [],
        y: [],
      }],

      plotly_attempts_before_win_layout: {
        title: 'Defeats before win',
        xaxis: {
          type: 'category',
          tickmode: 'array',
          tickvals: [0, 5, 10, 15, 20, 25, 30, 35, 40],
          ticktext: ['0', '5', '10', '15', '20', '25', '30', '35', '40'],
        },
        yaxis: {
          title: 'Amount of players',
        },
      },

      //-----------------------------------------------------------------------

      plotly_attempts_before_win_without_boosters_data: [{
        type: 'bar',
        x: [],
        y: [],
      }],

      plotly_attempts_before_win_without_boosters_layout: {
        title: 'Defeats before win without boosters',
        xaxis: {
          type: 'category',
          tickmode: 'array',
          tickvals: [0, 5, 10, 15, 20, 25, 30, 35, 40],
          ticktext: ['0', '5', '10', '15', '20', '25', '30', '35', '40'],
        },
        yaxis: {
          title: 'Amount of players',
        },
      },

      //-----------------------------------------------------------------------

      plotly_attempts_data: [{
        type: 'bar',
        x: [],
        y: [],
      }],

      plotly_attempts_layout: {
        title: 'Attempts',
        xaxis: {
          type: 'category',
          tickmode: 'array',
          tickvals: [1, 5, 10, 15, 20, 25, 30, 35, 40],
          ticktext: ['1', '5', '10', '15', '20', '25', '30', '35', '40'],
        },
        yaxis: {
          title: 'Amount of players',
        },
      },

      //-----------------------------------------------------------------------

      plotly_goal_progress_data: [],
      plotly_goal_progress_layout: [],
  
      plotly_turns_taken_data: [],

      plotly_turns_taken_layout: {
        title: 'Turns taken to win',
        barmode: 'group',
      },

      plotly_turns_taken_without_boosters_data: [],
      plotly_turns_taken_without_boosters_layout: {
        title: 'Turns taken to win without boosters',
        barmode: 'group',
      },

      updating: false,
    };
  },

  computed: {
    /** @returns {number} */
    sequenceProtoId() {
      return this.levelVarId.sequenceProtoId;
    },

    /** @returns {number} */
    levelNumber() {
      return this.levelVarId.number;
    },

    /** @returns {number} */
    levelProtoId() {
      return this.levelVarId.protoId;
    },

    /** @returns {string} */
    levelVarName() {
      return getLevelVarName(this.levelProtoId);
    },

    /** @returns {number} */
    revisionNumber() {
      return this.level.ID.Revision;
    },

    /** @returns {boolean} */
    mayManage() {
      return isRoleAdmin(this.actor.role);
    },

    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    /** @returns {Object} */
    activeRevision7DaysStat() {
      return this.level.activeRevision7DaysStat;
    },

    /** @returns {boolean} */
    hasABTestLevels() {
      if(!('ABTestLevels' in this.level)) {
        return false;
      }

      const abTestLevels = this.level.ABTestLevels;
      if(abTestLevels === undefined || abTestLevels === null) {
        return false;
      }

      return abTestLevels.length > 0;
    },

    /** @returns {boolean} */
    canInteract() {
      return !this.updating;
    },

    /** @returns {Object} */
    sequenceQuery() {
      return {
        audience: convertOptionalValueToQueryParam(this.audienceId),
      };
    },
  },

  created() {
    this.loadLevelVarSegment();
  },

  methods: {
    loadLevelVarSegment() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = `/m3/sequences/${this.sequenceProtoId}/levels/${this.levelNumber}/${this.levelProtoId}`;

      const requestConfig = {
        headers: {
          [TRACE_ID_HEADER_NAME]: genTraceId()
        },
      };

      if(this.audienceId !== null) {
        const params = {
          audience: this.audienceId,
        };
        requestConfig.params = params;
      }

      HTTP.get(url, requestConfig)
      .then(response => {
        const report = response.data.data;

        this.loadSeedList(report);
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    loadSeedList(report) {
      const revision = report.level.ID.Revision;
      const url = `/m3/sequences/${this.sequenceProtoId}/levels/${this.levelNumber}/${this.levelProtoId}/revision/${revision}/seed_list`;

      HTTP.get(url)
      .then(response => {
        const level = report.level;
        const seeds = response.data.data;
        console.log('seeds:', seeds);

        this.level = level;
        this.reportGenerationTime = report.reportGenerationTime;
        this.fillPlotsData(level.LevelStats);
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });

    },

    fillPlotsData(data) {
      const averageTurnsToWinBySeed = {
        type: 'bar',
        x: [],
        y: [],
      };

      data.AverageTurnsToWinBySeed.forEach(el => {
        averageTurnsToWinBySeed.x.push(`seed#${el.Number}`)
        averageTurnsToWinBySeed.y.push(el.Value)
      });
      this.plotly_avg_attempts_to_win_by_seed_data = [averageTurnsToWinBySeed];


      if('attemptsBeforeWin' in data) {
        const attemptsBeforeWin = {
          type: 'bar',
          x: [],
          y: [],
        };

        const groups = groupAttempts(0, data.attemptsBeforeWin);
        for(const group of groups) {
          attemptsBeforeWin.x.push(group.getName());
          attemptsBeforeWin.y.push(group.getValue());
        }

        this.plotly_attempts_before_win_data = [attemptsBeforeWin];
      }


      if('attemptsBeforeWinWithoutBoosters' in data) {
        const attemptsBeforeWinWithoutBoosters = {
          type: 'bar',
          x: [],
          y: [],
        };

        const groups = groupAttempts(0, data.attemptsBeforeWinWithoutBoosters);
        for(const group of groups) {
          attemptsBeforeWinWithoutBoosters.x.push(group.getName());
          attemptsBeforeWinWithoutBoosters.y.push(group.getValue());
        }

        this.plotly_attempts_before_win_without_boosters_data = [attemptsBeforeWinWithoutBoosters];
      }


      if('attempts' in data) {
        const attempts = {
          type: 'bar',
          x: [],
          y: [],
        };

        const groups = groupAttempts(1, data.attempts);
        for(const group of groups) {
          attempts.x.push(group.getName());
          attempts.y.push(group.getValue());
        }

        this.plotly_attempts_data = [attempts];
      }


      var GoalStats = [];
      data.GoalStats.forEach(goalStat => {
        this.plotly_goal_progress_layout.push({
          title: `Goal progress #${goalStat.Number} ${goalStat.Name}`,
          barmode: 'group',
        });
        var levels = [];
        goalStat.GoalProgresses.forEach(goalProgress => {
          var level = {
            name: `level revision#${goalProgress.LevelID.Revision}`,
            type: 'bar',
            x: [],
            y: [],
          };
          goalProgress.Groups.forEach(group => {
            var playersPart = Number.parseFloat(100*group.PlayersPart).toFixed(2)
            level.x.push(group.Completion)
            level.y.push(playersPart)
          });
          levels.push(level)
        });

        GoalStats.push(levels)
      });
      this.plotly_goal_progress_data = GoalStats;

      var TurnsTaken = [];
      data.TurnsTaken.forEach(turnTakenByRevision => {
        var level = {
          name: `level revision#${turnTakenByRevision.LevelID.Revision}`,
          type: 'bar',
          x: [],
          y: [],
        };
        turnTakenByRevision.Turns.forEach(turn => {
          var winsPart = Number.parseFloat(100*turn.WinsPart).toFixed(2)
          level.x.push(turn.Number)
          level.y.push(winsPart)
        });
        TurnsTaken.push(level);
      });
      this.plotly_turns_taken_layout = {
        title: `Turns taken to win. Turns limit: ${this.level.TurnsLimit}`,
        barmode: 'group'
      };
      this.plotly_turns_taken_data = TurnsTaken;

      //-----------------------------------------------------------------------

      if('TurnsTakenWithoutBoosters' in data) {
        const turnsTakenWithoutBoosters = [];

        data.TurnsTakenWithoutBoosters.forEach(turnTakenByRevision => {
          const level = {
            name: `level revision#${turnTakenByRevision.LevelID.Revision}`,
            type: 'bar',
            x: [],
            y: [],
          };
          turnTakenByRevision.Turns.forEach(turn => {
            const winsPart = Number.parseFloat(100*turn.WinsPart).toFixed(2);
            level.x.push(turn.Number);
            level.y.push(winsPart);
          });
          turnsTakenWithoutBoosters.push(level);
        });

        this.plotly_turns_taken_without_boosters_layout = {
          title: `Turns taken to win without boosters. Turns limit: ${this.level.TurnsLimit}`,
          barmode: 'group'
        };

        this.plotly_turns_taken_without_boosters_data = turnsTakenWithoutBoosters;
      }

    },

    update() {
      if(this.updating) {
        return;
      }

      notifier.deleteSenderNotifications(this);

      this.updating = true;

      const url = `/m3/update_and_get_level_report`;

      const formData = new FormData();
      formData.set('sequence_proto_id', this.sequenceProtoId);
      formData.set('level_number',      this.levelNumber);
      formData.set('level_proto_id',    this.levelProtoId);

      if(this.audienceId !== null) {
        formData.set('audience', this.audienceId);
      }

      HTTP.post(url, formData)
      .then(response => {
        const report = response.data.data;
        this.level = report.level;
        this.reportGenerationTime = report.reportGenerationTime;
        this.fillPlotsData(this.level.LevelStats);

        this.updating = false;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
        notifier.showSuccess('Report updated.');
      })
      .catch(e => {
        this.updating = false;
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(e.response.data, {sender: this});
      });
    },

    updateActualRevisionStat() {
      if(this.updating) {
        return;
      }

      notifier.deleteSenderNotifications(this);

      this.updating = true;

      const url = `/m3/update_and_get_actual_revision_stat`;

      const formData = new FormData();
      formData.set('sequence_proto_id', this.sequenceProtoId);
      formData.set('level_number',      this.levelNumber);
      formData.set('level_proto_id',    this.levelProtoId);

      if(this.audienceId !== null) {
        formData.set('audience', this.audienceId);
      }

      HTTP.post(url, formData)
      .then(() => {
        //console.log(response);
        //const report = response.data.data;
        //this.level = report.level;
        //this.reportGenerationTime = report.reportGenerationTime;
        //this.fillPlotsData(this.level.LevelStats);

        this.updating = false;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
        notifier.showSuccess('Report updated.');
      })
      .catch(e => {
        this.updating = false;
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(e.response.data, {sender: this});
      });
    },

    formatValue(value, fractionDigits) {
      var digits = (fractionDigits === null || fractionDigits === undefined) ? 2 : fractionDigits;
      var number = Number.parseFloat(value).toFixed(digits);
      return number;
    },

    formatValueAsPercent(value, fractionDigits) {
      return this.formatValue(value*100, fractionDigits);
    },
  },

  filters: {
    getAudienceName,
    zeroToNull,
    convertLevelIDObjToRevisionId,
  },
}

const FIRST_GROUPED_ATTEMPT_NUMBER = 41;
const LAST_GROUPED_ATTEMPT_NUMBER = 101;
const NUM_STEP = 10;

// Столбцы после 40 нужно группировать.
// Каждые 10 столбцов объединются.
// Столбцы 41 - 50 объединяются в первый сгруппированный столбец.
// Столбцы 51 - 60 объединяются во второй сгруппированный столбец.
// Столбцы 61 - 70 объединяются в 3-й сгруппированный столбец.
// Столбцы 71 - 80 объединяются в 4-й сгруппированный столбец.
// Столбцы 81 - 90 объединяются в 5-й сгруппированный столбец.
// Столбцы 91 - 100 объединяются в 6-й сгруппированный столбец.
//
// В конце идет столбец 101+.

class ValueGroup {
  constructor(xMin, xMax) {
    this.xMin = xMin;
    this.xMax = xMax;
    this.ySum = 0;
  }

  getName() {
    if(this.xMin === this.xMax) {
      return this.xMin.toString();
    }
    if(this.xMax === Infinity) {
      return this.xMin + '+';
    }
    return this.xMin.toString() + '-' + this.xMax.toString();
  }

  contains(x) {
    return x >= this.xMin && x <= this.xMax;
  }

  addValue(value) {
    this.ySum += value;
  }

  getValue() {
    return this.ySum;
  }
}

/**
 * @param {ValueGroup[]} groups
 * @param {number} x
 * @returns {ValueGroup}
 */
function findValueGroup(groups, x) {
  for(const group of groups) {
    if(group.contains(x)) {
      return group;
    }
  }
  return null;
}


/**
 * Пример
 * 
 * attempts
 * [
 *   {"number":   1, "value": 20000},
 *   {"number":   2, "value": 10000},
 *   {"number":  41, "value":  2000},
 *   {"number":  42, "value":  1500},
 *   {"number":  50, "value":  1000},
 *   {"number":  51, "value":   200},
 *   {"number":  52, "value":   150},
 *   {"number":  60, "value":   100},
 *   {"number":  91, "value":    20},
 *   {"number":  92, "value":    15},
 *   {"number": 100, "value":    10},
 *   {"number": 101, "value":     3},
 *   {"number": 102, "value":     2},
 *   {"number": 103, "value":     1},
 *   {"number": 104, "value":     1},
 *   {"number": 108, "value":     1},
 * ]
 * 
 * result
 * [
 *   {"number":       "1", "value": 20000},
 *   {"number":       "2", "value": 10000},
 *   {"number":   "41-50", "value":  4500},
 *   {"number":   "51-60", "value":   450},
 *   {"number":  "91-100", "value":    45},
 *   {"number":    "101+", "value":     6},
 * ]
 *
 * @param {Object[]} attempts
 * @returns {Object[]}
 */
function groupAttempts(minNumber, attempts) {
  if(attempts.length === 0) {
    return [];
  }

  const maxNumber = getMaxNumber(attempts);
  const groups = createAttempGroups(minNumber, maxNumber);
  
  for(const attempt of attempts) {
    const group = findValueGroup(groups, attempt.number);
    group.addValue(attempt.value);
  }

  return groups;
}

function getMaxNumber(attempts) {
  let maxNumber = attempts[0].number;
  for(const attempt of attempts) {
    if(attempt.number > maxNumber) {
      maxNumber = attempt.number;
    }
  }
  return maxNumber;
}

function createAttempGroups(minNum, maxNum) {
  const groups = [];

  for(let n = minNum; n <= maxNum && n < FIRST_GROUPED_ATTEMPT_NUMBER; n++) {
    let group = new ValueGroup(n, n);
    groups.push(group);
  }

  for(let n = FIRST_GROUPED_ATTEMPT_NUMBER; n <= maxNum && n < LAST_GROUPED_ATTEMPT_NUMBER; n += NUM_STEP) {
    let group = new ValueGroup(n, n + NUM_STEP - 1);
    groups.push(group);
  }

  if(maxNum >= LAST_GROUPED_ATTEMPT_NUMBER) {
    let group = new ValueGroup(LAST_GROUPED_ATTEMPT_NUMBER, Infinity);
    groups.push(group);
  }

  return groups;
}
</script>

<style scoped>
.m3-props-table td:first-child {
  padding-right: .5rem;
}

.stat-table {
  max-width: 600px;
  margin-bottom: 3rem;
}

.stat-table th {
  text-align: center;
}

.report-info {
  font-size: 0.9rem;
  margin-bottom: 1em;
}

.gen-time {
  margin-bottom: 0.5em;
}
</style>
